import { MerchType } from '@api';
import {
  getValueByPath,
  PersonAnchor,
  TouringCardTableRow,
  TouringCardTableRowLabel,
  TouringCardTableRowValue,
} from '@common';
import { useTranslation } from 'react-i18next';
import { VenueMerchTableRowType } from '../../data';

type VenueMerchTableRowPropsType = {
  venueMerch: MerchType;
  row: VenueMerchTableRowType;
};
export const VenueMerchTableRow: React.FC<VenueMerchTableRowPropsType> = ({
  venueMerch,
  row,
}) => {
  const { t } = useTranslation('venueDetailsOverview');

  const label = t(`VENUE_MERCH.ROWS.${row.label}`);
  const value = getValueByPath(venueMerch, row.accessor);

  const getRenderValue = () => {
    if (!value) return t('NO_DATA_PLACEHOLDER', { ns: 'common' });

    switch (row.accessor) {
      case 'contact':
        if (typeof value === 'string') return null;
        return (
          <PersonAnchor
            person={{
              type: 'PERSON',
              id: value.personId,
              name: `${value.personName} - ${value.companyName}`,
            }}
          />
        );
      case 'rate':
      case 'notes':
        return String(value);
    }
  };
  return (
    <TouringCardTableRow>
      <TouringCardTableRowLabel>{label}</TouringCardTableRowLabel>
      <TouringCardTableRowValue>{getRenderValue()}</TouringCardTableRowValue>
    </TouringCardTableRow>
  );
};
